import { Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import { AppDispatch, RootState } from "../../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import {
  getDateRange,
  scroll,
} from "../../../../components/utils/utils";
import "moment/locale/ar";
import { toGetServicesListRequests } from "../../../../apis/actions/services.actions";
import ServicesListRequest from "./ServicesListRequest";
import { getAllKorbaAssistance } from "../../../../apis/actions/korba.actions";
import CustomConfigProvider from "../../ProfileHeader";
const ServicesListRequestOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { data: servicesListRequest, loading } = useSelector(
    (state: RootState) => state?.services?.servicesListRequest
  );
  const { TotalApplications } = useSelector(
    (state: RootState) => state?.services
  );
  const { korbaAssitances } = useSelector((state: RootState) => state?.korbas);

  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  useEffect(() => {
    dispatch(getAllKorbaAssistance());
  }, [dispatch]);
  useEffect(() => {
    setCurrentPage(1);
  }, [state]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      toGetServicesListRequests({
        limit: itemPerPage,
        page: currentPage,
        date_from: date_from,
        date_to: date_to,
        assistance_id: selectedFilter,
      })
    );
  }, [dispatch, state, currentPage, selectedFilter]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.label);
      setCurrentPage(1);
    } else {
      setSelectedFilter(null);
    }
  };

  return (
    <>
      <CustomConfigProvider
        title="الترشحات للخدمات"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      >
        <Selects
          options={korbaAssitances}
          selectPlaceholder="نوع الخدمة"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>

      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : servicesListRequest?.length === 0 &&
        !selectedFilter &&
        // eslint-disable-next-line eqeqeq
        state.year == "" ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد ترشحات
        </p>
      ) : servicesListRequest?.length === 0 &&
        (selectedFilter || state.year !== "") ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد ترشحات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <ServicesListRequest requests={servicesListRequest} />
          </Row>
          <div className="takaful--pagination-container">
            {servicesListRequest &&
              Math.ceil(TotalApplications * itemPerPage) > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalApplications * itemPerPage)}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
    </>
  );
};

export default ServicesListRequestOverview;
